import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../views/Index.vue";
import merchantDomains from "../config/domain.json";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    beforeEnter() {
      window.location.replace("https://www.rush.ph/");
    }
  },
  // Main Router
  {
    path: "/:subdomain",
    name: 'Index',
    component: Index,
    redirect: "/:subdomain/checkout",
    children: [
      {
        path: "/:subdomain/checkout/:checkout_uuid",
        name: "Checkout",
        component: () => import("@/views/checkout/Index.vue"),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: "/:subdomain/checkout/card/details/",
        name: "CardDetails",
        component: () => import("@/views/checkout/CardDetails.vue"),
        meta: {
          requiresAuth: false,
          isFullScreen: true
        },
        props: true
      },
      {
        path: "/:subdomain/checkout/card/payment/",
        name: "CardPayment",
        component: () => import("../views/checkout/CardPayment.vue"),
        meta: {
          isFullScreen: true
        }
      },
      {
        path: "/:subdomain/checkout/payment/success",
        name: "PaymentSuccess",
        component: () => import("../views/checkout/PaymentSuccess.vue"),
        meta: {
          isFullScreen: true
        }
      },
      {
        path: "/:subdomain/checkout/payment/failed",
        name: "PaymentFailed",
        component: () => import("../views/checkout/PaymentFailed.vue"),
        meta: {
          isFullScreen: true
        }
      },
      {
        path: "/:subdomain/checkout/:paymongo_type/details/",
        name: "PayMongoDetails",
        component: () => import("../views/checkout/PayMongoDetails.vue"),
        meta: {
          isFullScreen: true
        },
        props: true
      },
      {
        path: "/:subdomain/checkout/:paymongo_type/payment",
        name: "PayMongoPayment",
        component: () => import("../views/checkout/PayMongoPayment.vue"),
        meta: {
          isFullScreen: true
        }
      },
      {
        path: "/:subdomain/orders/:order_id",
        name: "Orders",
        component: () => import("@/components/orders/IndividualOrder.vue")
      }
    ]
  },
  // Routing for Anything Related to Authentication (Login, Register, Forgot PIN)
  {
    path: "/:subdomain/terms-of-use",
    name: "TermsOfUse",
    component: () => import("../views/TermsOfUse.vue")
  },
  {
    path: "/:subdomain/privacy-policy",
    name: "PrivacyPolicy",
    component: () => import("../views/PrivacyPolicy.vue")
  },
  {
    path: "/:subdomain/maintenance",
    name: "Maintenance",
    component: () => import("../views/Maintenance")
  },
  {
    path: "/:subdomain/404",
    name: "404",
    component: () => import("@/views/404")
  },
  {
    path: "/:subdomain/*",
    redirect: "/:subdomain/404"
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const subpath = merchantDomains[location.hostname];
  const subdomain = to.params.subdomain;

  // If location.hostname is a custom domain, Rewrire subpath.
  if (subpath) {
    const rgxp = new RegExp("^/" + subpath);
    if (!to.path.match(rgxp)) next({ path: "/" + subpath + "/" });
  }
  // Else If subdomain is included on merchants with custom domains, redirect to custom domain.
  else if (subdomain && Object.values(merchantDomains).includes(subdomain)) {
    const domain = Object.keys(merchantDomains).find(
      domain => merchantDomains[domain] == subdomain
    );
    window.location.replace(`https://${domain}/${subdomain}`);
  }

  if (to.matched.some(record => record.meta.isFullScreen))
    store.commit("estore/SET_IS_FULL_SCREEN", true);
  else store.commit("estore/SET_IS_FULL_SCREEN", false);

  if (to.matched.some(record => record.meta.hideMap))
    store.commit("estore/SET_HIDE_MAP", true);
  else store.commit("estore/SET_HIDE_MAP", false);

  next();
});

export default router;
